/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHospitalCircle = createReactComponent("outline", "hospital-circle", "IconHospitalCircle", [["path", { "d": "M10 16v-8", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }], ["path", { "d": "M14 16v-8", "key": "svg-2" }], ["path", { "d": "M10 12h4", "key": "svg-3" }]]);

export { IconHospitalCircle as default };
//# sourceMappingURL=IconHospitalCircle.mjs.map
